import type { FillApplicationState } from '@/models/fillApplication'
import { CustomerLinksCard } from './CustomerLinksCard'
import { FillTabHeader } from './FillTabHeader'
import { SendToCarriersCard } from './SendToCarriersCard'
import { SentBanner } from './SentBanner'

interface ConfirmationStepProps {
  orgId: string
  state: FillApplicationState
  dirtyLabels: string[]
  sending: boolean
  error: string | null
  blockedNonce: number
  onSend: () => void
}

export function ConfirmationStep({ orgId, state, ...send }: ConfirmationStepProps) {
  return (
    <div className="flex flex-col gap-4">
      <FillTabHeader title="Confirmation" />
      {state.sent ? (
        <SentBanner orgId={orgId} state={state} />
      ) : (
        <SendToCarriersCard state={state} {...send} />
      )}
      <CustomerLinksCard orgId={orgId} state={state} />
    </div>
  )
}
